import { render, staticRenderFns } from "./Lavoro.vue?vue&type=template&id=108979a6"
import script from "./Lavoro.vue?vue&type=script&lang=js"
export * from "./Lavoro.vue?vue&type=script&lang=js"
import style0 from "./Lavoro.vue?vue&type=style&index=0&id=108979a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports